
import { defineComponent } from "vue";
import { Vector2 } from "../../math/vector2";
import gameApplication from "../../game/game-app";
import { Constants } from "@/math/constants";

export default defineComponent({
  name: "BigHitPositionModal",
  
  data: () => ({
    whiteHitPositionBallRadus: 100, // large white ball diameter is 200px

    position: {
      top: 0,
      left: 0,
      isDraging: false,
      initTop: 0,
      initLeft: 0,
    },
  }),

  setup() {
  },

  mounted() {
    const markerX = gameApplication.getBillardGame().hitPosition[0];
    const markerY = gameApplication.getBillardGame().hitPosition[1];
    if (markerX > 0 && markerY > 0) {
      this.setBallHitPosition(markerX, markerY);
    }
  },

  methods: {
    onCancel(): void {
      gameApplication.getBillardGame().stick.active = true;

      this.$emit("close");
    },

    //
    // Hit position related code functions.
    // 
    mouseEnter(event: MouseEvent): void {
      this.position.isDraging = false;
    },

    mouseLeave(event: MouseEvent): void {
      this.position.isDraging = false;
    },

    mouseMove(event: MouseEvent): void {
       if (!gameApplication.getBillardGame().isOpponentTurn() ||
        gameApplication.getGameKind() === 'PRACTICE') {
        const posX = event.clientX;
        const posY = event.clientY;
        if (this.position.isDraging)  {
          this.setMarkerIcon(posX, posY); // set the hit position on screen 
        }
      }
    },

    ballMouseDown(event: MouseEvent): void {
      const { clientX, clientY } = event;
      this.setMarkerIcon(clientX, clientY);
    },

    mouseDown(event: MouseEvent): void {
      this.position.isDraging = true;
    },

    mouseUp(event: MouseEvent): void {
      this.position.isDraging = false;
    },

    /**
     * This is used with the large hit position mode.
     * It is used to re-set the large hit position after 
     * the modal has been closed and re-opned.
     */
    setBallHitPosition(markerX: number, markerY: number): void {
      const markerIconEl = document.getElementById('strike-marker-big-icon');
     
      // Move the red marker icon on the screen.
      markerIconEl.style.left = (markerX - 4) + 'px'; 
      markerIconEl.style.top = (markerY - 12) + 'px';
    },

   /**
    * Set the player or opponent hit position (clicked or dragged). 
    */ 
    setMarkerIcon(clientX: number, clientY: number, isSendPosition: boolean): void {   
      const whiteBallEl = document.getElementById('white-ball-big-id');
      const markerIconEl = document.getElementById('strike-marker-big-icon');

      addEventListener('load', () => {});
      
      const whiteBallRect = whiteBallEl.getBoundingClientRect();
      const wbWidth = whiteBallEl.clientWidth;
      const wbHeight = whiteBallEl.clientHeight;

      // Calcualte the position to set the red market icon.
      const markerX = clientX - whiteBallRect.left;
      const markerY = clientY - whiteBallRect.top;

      if ((markerX > 0 && markerX < wbWidth) && (markerY > 0 && markerY < wbHeight)) {  
        // Move the red marker icon on the screen.
        // These hardcoded values are visual adjustments to the red marker cross.
        markerIconEl.style.left = (markerX - 4) + 'px'; 
        markerIconEl.style.top = (markerY - 12) + 'px';
      } 

      gameApplication.getBillardGame().hitPosition = [markerX, markerY];

      // Move the cue stick hit position (diagional) on the screen.
      gameApplication.getBillardGame().updateHitOrigin(this.calculateHitOrigin(markerX));

      // The screen marker ranges from 1 to the diameter of the white hit position ball.
      // Convert the screen markers to range from -1 to +1 for the hit position vector.
      const positionX = this.calculateHitPosition(markerX);
      const positionY = -this.calculateHitPosition(markerY);

      // Update the hit position vector value for the game.
      gameApplication.getBillardGame().updateHitPosition(new Vector2(positionX, positionY));

      // send the screen hit point to the opponent
      if (gameApplication.getGameKind() !== 'PRACTICE') {
        gameApplication.sendHitPoint(markerX / Constants.HIT_POSITION_RATIO, markerY / Constants.HIT_POSITION_RATIO);  
      }  
    },

    /**
     * Reset the hit position and hit orgin.
     */ 
    resetHit(): void {
      const markerIconEl = document.getElementById('strike-marker-big-icon');
      const adjustment = 5; // FIXME: this is a temporary adjustment
     
      // Move the red marker icon on the screen.
      markerIconEl.style.left = (this.whiteHitPositionBallRadus - adjustment - 4) + "px"; 
      markerIconEl.style.top = (this.whiteHitPositionBallRadus - adjustment - 12) + "px";

      gameApplication.getBillardGame().hitPosition = [0, 0];
    },

    /**
     * The "hit origin" used is to update the cue stick position on the screen only. 
     * When the hit position is changed left or right the cue stick position is also
     * adjusted on the screen. This value does not affect the gameplay.
     */ 
    calculateHitOrigin(x: number): number {
      const whiteHitPositionBallDiameter = this.whiteHitPositionBallRadus * 2;
      x = x > whiteHitPositionBallDiameter ? whiteHitPositionBallDiameter : x;
      x = x < 1 ? 1 : x;
      // These hardcoded values are visual.
      return 22 - 0.2 * x;
    },

    /**
     * Convert the screen markers to range from -1 to +1 for the hit position vector.
     */
    calculateHitPosition(n: number): number {
      const whiteHitPositionBallDiameter = this.whiteHitPositionBallRadus * 2;
      n = n > whiteHitPositionBallDiameter ? whiteHitPositionBallDiameter : n;
      n = n < 1 ? 1 : n;
      return n = (n - this.whiteHitPositionBallRadus) / this.whiteHitPositionBallRadus;
    },
  },
});
